module.exports = __webpack_public_path__ + "dm.5c6d3f5b4699e93e59b6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/dm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/dm.svg
// module chunks = styles